import axios from "axios";
import {updateCartCount} from "./microcart";
import {toggleAddedToCart} from "./added-to-cart";
import { loader } from './loader.js';

export const addToCartHandler = async (e, customQuantity = null, openMicrocart = true) => {
    e.preventDefault();

    const form = e.currentTarget;
    const submitButton = form.querySelector('.js-order-button');

    form.setAttribute('data-state', 'loading');
    submitButton.classList.add('loading');

    const formData = new FormData(form);

    if(customQuantity) {
        formData.set('quantity', customQuantity);
    }

    try {
        let {status} = await axios.post(`${form.action}.js`, formData);

        if(status === 200) {
            await updateCartCount();

            const quantityField = form.querySelector('.js-quantity-field');

            if(quantityField) {
                if(quantityField.min) {
                    quantityField.value = quantityField.min;
                } else {
                    quantityField.value = 1;
                }
            }

            form.setAttribute('data-state', 'done');
            submitButton.classList.remove('loading');
            form.removeAttribute('data-state');

            if(openMicrocart) {
                toggleAddedToCart();
            }
        }
        if(openMicrocart) {
            window.dispatchEvent(new Event('popup.toggle.cart.added-to-cart'));
        }
    } catch (e) {
        console.log('error', e);
        //form.dispatchEvent(new Event('submit'));
    }
}
